<script lang="ts">
  interface Props {
    status: 'loading' | 'pending' | 'rejected';
    onLogout: () => void;
  }

  let { status, onLogout }: Props = $props();
</script>

{#if status === 'loading'}
  <div class="approval-loading">
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
{:else if status === 'pending'}
  <div class="approval-blocked">
    <div class="blocked-card">
      <div class="blocked-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <h1>Account Pending Approval</h1>
      <p>Your EQUOS account is currently being reviewed by our team.</p>
      <p>Review typically takes 1 hour to 3 business days. You'll receive an email once your account is approved with instructions to set your password.</p>
      <div class="contact-info">
        <p>Questions? Contact us at <a href="mailto:support@equosnine.com">support@equosnine.com</a></p>
      </div>
      <button class="btn-secondary" onclick={onLogout}>Sign Out</button>
    </div>
  </div>
{:else if status === 'rejected'}
  <div class="approval-blocked">
    <div class="blocked-card rejected">
      <div class="blocked-icon rejected">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" stroke-linecap="round" />
          <line x1="9" y1="9" x2="15" y2="15" stroke-linecap="round" />
        </svg>
      </div>
      <h1>Application Not Approved</h1>
      <p>Unfortunately, your application was not approved at this time.</p>
      <p>Please contact support for more information.</p>
      <div class="contact-info">
        <p><a href="mailto:support@equosnine.com">support@equosnine.com</a></p>
      </div>
      <button class="btn-secondary" onclick={onLogout}>Sign Out</button>
    </div>
  </div>
{/if}

<style>
  .approval-loading {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    gap: 1rem;
  }

  .approval-loading .spinner {
    width: 48px;
    height: 48px;
    border: 4px solid #e5e7eb;
    border-top-color: #4A7DFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .approval-loading p {
    color: #666;
    font-size: 1rem;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .approval-blocked {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #4A7DFF 0%, #6B5CE7 100%);
    padding: 2rem;
  }

  .blocked-card {
    max-width: 500px;
    width: 100%;
    background: white;
    border-radius: 12px;
    padding: 3rem 2rem;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  }

  .blocked-icon {
    width: 5rem;
    height: 5rem;
    margin: 0 auto 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(102, 126, 234, 0.15);
    color: #4A7DFF;
  }

  .blocked-icon svg {
    width: 3rem;
    height: 3rem;
  }

  .blocked-icon.rejected {
    background: rgba(220, 38, 38, 0.15);
    color: #dc2626;
  }

  .blocked-card h1 {
    font-size: 1.75rem;
    color: #333;
    margin: 0 0 1rem;
  }

  .blocked-card p {
    color: #666;
    font-size: 1rem;
    line-height: 1.6;
    margin: 0 0 0.75rem;
  }

  .blocked-card .contact-info {
    margin: 1.5rem 0;
    padding: 1rem;
    background: #f5f7fa;
    border-radius: 8px;
  }

  .blocked-card .contact-info p {
    margin: 0;
  }

  .blocked-card .contact-info a {
    color: #4A7DFF;
    text-decoration: none;
  }

  .blocked-card .contact-info a:hover {
    text-decoration: underline;
  }

  .btn-secondary {
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 1rem;
    background: white;
    color: #4A7DFF;
    border: 1px solid #4A7DFF;
  }

  .btn-secondary:hover {
    background: #f5f7ff;
  }
</style>
